var Component = require("!../../../_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./UEditor.vue"),
  /* template */
  require("!!../../../_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-056d8c72\",\"hasScoped\":false}!../../../_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./UEditor.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/_vue-ueditor@0.1.3@vue-ueditor/src/components/UEditor.vue
// module id = 720
// module chunks = 1